import uuidV4 from 'uuid/v4'

function generateGuid() {
  return uuidV4()
}

function getQueryStringValue(name) {
  if (!name) throw new Error('name is required')

  if (!window || !window.location || !window.location.href) return null

  name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]"); //eslint-disable-line

  const regexS = `[\\?&]${name}=([^&#]*)`
  const regex = new RegExp(regexS)
  const results = regex.exec(window.location.href)

  if (results === null) return ''

  return results[1]
}

function getDayName(dayNumber) {
  dayNumber = parseInt(dayNumber, 10)

  switch (dayNumber) {
    case 0:
      return 'Sunday'
    case 1:
      return 'Monday'
    case 2:
      return 'Tuesday'
    case 3:
      return 'Wednesday'
    case 4:
      return 'Thursday'
    case 5:
      return 'Friday'
    case 6:
      return 'Saturday'
    default:
      return ''
  }
}

export default {
  generateGuid,
  getQueryStringValue,
  getDayName,
}



// WEBPACK FOOTER //
// ./src/utils/utils.js